/* @flow */

export default class CompanyPerson {
  id: number;
  firstName: string;
  lastName: string;
  functionName: string;
}
